import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { LoginService } from "./login.service";

@Component({
  selector: "login",
  template: "", //No login page
  providers: [LoginService]
})
export class LoginComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {
    this.route.params.subscribe((params: Params) => {
      let magicLink = params["shortId"];
      let email = "";
      if (params["email"]) {
        let tmpEmail = params["email"];
        email = this.getEmail(tmpEmail);
      }
      if (magicLink) {
        this.doLogin(magicLink, email);
      } else {
        //this is deprecated
        this.route.queryParams.subscribe((params: Params) => {
          let magicLink = params["magic_link"];
          this.doLogin(magicLink, email);
        });
      }
    });
  }

  doLogin(magicLink, email) {
    if (localStorage.hasOwnProperty("appliedFilterValues")) {
      localStorage.removeItem("appliedFilterValues");
    }
    if (localStorage.hasOwnProperty("filter_values")) {
      localStorage.removeItem("filter_values");
    }

    this.loginService
      .login(magicLink, email)
      .then((res: any) => {
        this.router.navigateByUrl("/");
      })
      .catch(e => {
        this.router.navigateByUrl("/error/not-authorised");
      });
  }

  getEmail(email) {
    let urlPattern = /@/g;
    if (email.match(urlPattern)) {
      return email;
    } else {
      let emailBuffer = new Buffer(email).toString("utf8");
      let newEmail = new Buffer(emailBuffer, "base64").toString("utf8");
      if (newEmail.match(urlPattern)) {
        return newEmail;
      } else {
        return "";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts